export default __webpack_public_path__ + "static/media/Programming4.b16af969.png";